import { useIntl } from 'react-intl';
import { DatedEvidence, TableCells, TableColumn } from '@eas/common-web';
import { Paragraph } from '@models';

export function useColumns(): TableColumn<Paragraph>[] {
  const intl = useIntl();
  const { datedColumns } = DatedEvidence.useDatedColumns<Paragraph>();

  return [
    {
      datakey: 'label',
      filterkey: 'location.name',
      sortkey: 'location.name',
      name: intl.formatMessage({
        id: 'TAPIS__PARAGRAPH__COLUMN__LABEL',
        defaultMessage: 'Umístění',
      }),
      width: 150,
      CellComponent: TableCells.TextCell,
      sortable: true,
      filterable: true,
    },
    {
      datakey: 'location',
      filterkey: 'location.id',
      sortkey: 'location.id',
      name: intl.formatMessage({
        id: 'TAPIS__PARAGRAPH__COLUMN__LOCATION',
        defaultMessage: 'Kód umístění',
      }),
      width: 150,
      CellComponent: TableCells.TextCell,
      sortable: true,
      filterable: true,
    },

    ...datedColumns,
  ];
}
